import { render, staticRenderFns } from "./home-organization.vue?vue&type=template&id=1d9da4ba&scoped=true"
var script = {}
import style0 from "./home-organization.vue?vue&type=style&index=0&id=1d9da4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9da4ba",
  null
  
)

export default component.exports